import { ActionTitle, TitleConfig } from './interfaces';

export const TABS = {
  WORK_LOG: 'work-log',
  ANALYSIS_RESULTS: 'analysis-results',
  RUNS: 'runs',
};

export const ANALYSIS_EXECUTION_STATUS = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
  FAILED: 'FAILED',
};

export const KPI_STATUS = {
  NOT_APPLICABLE: 'not applicable',
  ACHIEVING: 'achieving / progressing',
};

export const ERROR_TYPE = {
  NO_QE_METRICS: 'no-qe-metrics',
  GENERIC: 'generic',
  ANALYSIS_TRIGGERED: 'already in progress',
  KPI_BREAKDOWN_DATA_FETCH_FAILED: 'failed to retrieve kpi breakdown data',
  NO_STREAM_RESPONSE: 'no stream response received for work logs',
};

export const TITLE_NEXT_ACTIONS_MAP: Record<ActionTitle, TitleConfig> = {
  'Increase Sprint Activity': {
    nextAction:
      'Check if correct project is mapped to your product. If mapping is correct, select the project and start adding user stories using Planner agent',
    getUrl(apmNumber) {
      return `${window.location.origin}/provisioning-center/project/${apmNumber}/project-mapping`;
    },
  },
  'Zero Test Cases in ALM — Establish Test Coverage': {
    nextAction: 'Enable Planner / QE agent to create test cases',
    getUrl(apmNumber) {
      return `${window.location.origin}/provisioning-center/project/${apmNumber}/services/ado-planner-qe-bot`;
    },
  },
  'Automate Test Case Gap': {
    nextAction: 'Use Playwright template and start automating',
    getUrl() {
      return `${window.location.origin}/software-templates?filters%5Bkind%5D=template&filters%5Buser%5D=all&limit=20`;
    },
  },
  "Performance Test SLA's should be documented in PTaaS": {
    nextAction: 'Document SLAs in PTaaS',
    getUrl(apmNumber) {
      return `${window.location.origin}/provisioning-center/project/${apmNumber}/services/performance-test/sla`;
    },
  },
  'Execute Performance Test': {
    nextAction: 'Execute tests on PTaaS',
    getUrl(apmNumber) {
      return `${window.location.origin}/provisioning-center/project/${apmNumber}/services/performance-test/manage`;
    },
  },
  'Create Test Cases for Escaped Defects': {
    nextAction: 'Show QE Agent',
    getUrl() {
      return ``;
    },
  },
};
